import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CustomTextField from '../common/custom-components/customTextField';
import { required, password, email } from '../../constants/constants';
import InfoMessageBar from '../common/info-message/info-message';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
const useStyles = makeStyles(theme => ({
  root: {
    // height: '100vh',
  },
  divider: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: '#f0f2f4',
  },
  paper: {
    margin: theme.spacing(6, 6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paper2: {
    margin: theme.spacing(6, 6),
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#0073a8',
    borderRadius: 28,
    height: 42,
  },
  typography: {
    fontFamily: 'Helvetica',
  },
  typography2: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  icon: {
    color: '#0073a8',
    verticalAlign: 'middle',
  },
  subHeader: {
    fontWeight: 'bold',
    fontSize: '16',
    fontFamily: 'Arial',
    color: '#404040',
    paddingTop: 10,
    alignItems: 'center',
  },
}));

export function AgentLoginForm(props) {
  const classes = useStyles();
  console.log('Agent Login Form ', props);
  return (
    <React.Fragment>
      {props.showBanner && (
        <InfoMessageBar
          message={`Hours of operation are MON-FRI from 5AM to 9PM EST`}
          variant="warningF"
          icColor="warningIc"
          width="30em"
          style={{
            display: 'flex',
            fontSize: '22px',
            maxWidth: '100em',
          }}
        />
      )}
      <Grid container component="main" className={classes.root}>
        <CssBaseline />

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          elevation={6}
          square
        >
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            {props.successmsg && (
              <InfoMessageBar
                message={props.successmsg}
                variant="success"
                icColor="successIc"
              />
            )}
            {props.errors && (
              <InfoMessageBar
                icColor="errorIc"
                variant="error"
                message={props.errors}
              />
            )}
            {props.authErrors && (
              <InfoMessageBar variant="error" message={props.authErrors} />
            )}
            <form
              className={classes.form}
              noValidate
              onSubmit={props.handleSubmit}
            >
              <Field
                className="form-control form-control-lg TextField-border-radius"
                color="primary"
                component={CustomTextField}
                name="email"
                symbol="Email"
                placeholder="Email"
                required
                type="email"
                validate={[required, email]}
                variant="outlined"
              />

              <Field
                className="form-control form-control-lg TextField-border-radius"
                color="primary"
                component={CustomTextField}
                name="password"
                symbol="Password"
                placeholder="Password"
                required
                type="password"
                validate={[required, password]}
                variant="outlined"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={props.showBanner}
                className={classes.submit}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link to="/reset" variant="body2">
                    Forgot UserId/password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link to="/register">{`Don't have an account? Sign Up`}</Link>
                </Grid>
              </Grid>
            </form>
          </div>
          <Typography variant="h6" style={{ color: 'red', margin: 30 }}>
            Attention: This Portal is ONLY for Insurance Agents
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          component={Paper}
          elevation={6}
          square
        >
          <div className={classes.paper2}>
            <Typography variant="h5" className={classes.typography}>
              Don&apos;t have an FPL Non Cash Deposit Portal login yet? <br />{' '}
              Register now for online access
            </Typography>
            <Typography
              display="block"
              gutterBottom
              variant="h6"
              className={classes.subHeader}
            >
              Site benefits for your Business
            </Typography>
            <Divider
              variant="middle"
              orientation="horizontal"
              className={classes.divider}
            />

            <Typography
              variant="overline"
              display="block"
              gutterBottom
              className={classes.typography2}
            >
              {' '}
              <CheckCircleOutlineIcon
                className={classes.icon}
                align="left"
              />{' '}
              <span className="material-icons">
                Create and submit Non-Cash applications electronically
              </span>
            </Typography>
            <Divider
              variant="middle"
              orientation="horizontal"
              className={classes.divider}
            />
            <Typography
              variant="overline"
              display="block"
              gutterBottom
              className={classes.typography2}
            >
              <CheckCircleOutlineIcon className={classes.icon} align="left" />{' '}
              <span className="material-icons">
                Fast and secure application validation ensures accuracy
              </span>
            </Typography>
            <Divider
              variant="middle"
              orientation="horizontal"
              className={classes.divider}
            />
            <Typography
              variant="overline"
              display="block"
              gutterBottom
              className={classes.typography2}
            >
              <CheckCircleOutlineIcon className={classes.icon} align="left" />{' '}
              <span className="material-icons">
                Pre-Populated Non-Cash application with customer details
              </span>
            </Typography>
            <Divider
              variant="middle"
              orientation="horizontal"
              className={classes.divider}
            />
            <Typography
              variant="overline"
              display="block"
              gutterBottom
              className={classes.typography2}
            >
              <span className="material-icons">
                Hours of Operation <br />
                MONDAY - FRIDAY <br />
                5AM - 9PM EST
              </span>
            </Typography>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
AgentLoginForm.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  inProgress: PropTypes.bool,
  successmsg: PropTypes.string,
  authErrors: PropTypes.string,
  showBanner: PropTypes.bool,
};

export default reduxForm({
  form: 'agentLoginForm',
  // a unique identifier for this form
})(AgentLoginForm);
